
/* ============================== src/hooks/useTaskTabSync.js ============================== */
// src/hooks/useTaskTabSync.js
import { useEffect } from "react";
import { useControlledTab } from "./useControlledTab";
import { useStableModalHeight } from "./useStableModalHeight";

/**
 * Активная вкладка карточки задачи + одно правило автопереключения:
 *
 *   - если текущая вкладка вообще пропала из списка (например,
 *     закрылась вкладка «Подзадачи», потому что подзадач не осталось) -
 *     переключаемся на первую доступную.
 *
 * Раньше здесь было ещё одно правило: «часовая задача → уходим с
 * вкладки time на form». Оно отменено вместе с запретом на учёт часов
 * по часовым задачам: вкладка «Учёт времени» теперь доступна и им
 * (план - длина слота, но факт всё равно фиксируется: сделали за 3 ч
 * из 4, задержались на час). Единственная точка правила «часовая
 * задача не проверяет бюджет» - useTaskTimeLog.saveLog. Смятчение
 * UI-гейта (вкладка доступна) - index.jsx (сборка tabs).
 *
 * tabIdsSignature - строка вместо массива в зависимостях эффекта:
 * массив tabs пересоздаётся на каждом рендере, эффект гонялся бы
 * без надобности при каждом ре-рендере, а не только при реальном
 * изменении состава вкладок.
 */
export function useTaskTabSync(initialTab, onTabChange, tabs) {
  const [activeTab, handleTabChange] = useControlledTab(
    initialTab,
    onTabChange,
  );
  const bodyRef = useStableModalHeight(activeTab);

  const tabIdsSignature = tabs.map((t) => t.id).join(",");
  useEffect(() => {
    const ids = tabIdsSignature.split(",");
    if (!ids.includes(activeTab)) handleTabChange(ids[0] || "form");
  }, [tabIdsSignature, activeTab, handleTabChange]);

  return { activeTab, handleTabChange, bodyRef };
}
